module.exports = __webpack_public_path__ + "static/media/dongyanshan_plant.54763df9.png";